import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import { toggleColorEnum } from './toggleColorEnum'
import { Mixpanel } from '../../../../utils/Mixpanel'

export interface IToggleButton {
  nameLeft: string | JSX.Element
  nameRight: string | JSX.Element
  value: boolean
  setValue: (value: boolean) => void
  style?: React.CSSProperties
  className?: string
  disabled?: boolean
  toggleColor?: toggleColorEnum
  dataMixpanel?: { name: string; data?: any }
  dataTestId?: string
}

const ToggleButton = ({
  nameLeft,
  nameRight,
  value,
  setValue,
  style,
  className,
  disabled,
  toggleColor = toggleColorEnum.BLUE,
  dataMixpanel,
  dataTestId,
}: IToggleButton) => {
  // TODO - [DEPRECATED] - Remove this component once all the usages are replaced with the new component
  return (
    <div
      className={clsx(s.container, className, { [s.disabled]: disabled })}
      style={style}
    >
      <div
        className={clsx(s.leftSwitch, { [s.selected]: value })}
        style={value ? { borderColor: toggleColor, color: toggleColor } : {}}
        onClick={() => {
          if (!disabled) {
            setValue(true)
            if (dataMixpanel) {
              Mixpanel.track(dataMixpanel?.name, {
                value: nameLeft,
                data: dataMixpanel?.data,
              })
            }
          }
        }}
        data-testid={`${dataTestId}-left`}
      >
        <div style={value ? { color: toggleColor } : {}}>{nameLeft}</div>
      </div>

      <div
        className={clsx(s.rightSwitch, { [s.selected]: !value })}
        style={!value ? { borderColor: toggleColor, color: toggleColor } : {}}
        onClick={() => {
          if (!disabled) {
            setValue(false)
            if (dataMixpanel) {
              Mixpanel.track(dataMixpanel?.name, {
                value: nameRight,
                data: dataMixpanel?.data,
              })
            }
          }
        }}
        data-testid={`${dataTestId}-right`}
      >
        <div style={!value ? { color: toggleColor } : {}}>{nameRight}</div>
      </div>
    </div>
  )
}

export default ToggleButton
